<template>
  <div>
    <Form  label-position="left">
      <Row :gutter="40">
        <Col :xs="24" :sm="24" :md="12" :lg="4">
          <FormItem :label="$t('Employee_Code')" :label-width="80"><!--工号-->
            <Input v-model="searchItem.empCode" clearable />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="4">
          <FormItem :label="$t('Name')" :label-width="80"><!--姓名-->
            <Input v-model="searchItem.userName" clearable/>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="2" :lg="2">
          <Button @click="getData">{{$t('Search')}}</Button><!--检 索-->
        </Col>
      </Row>
    </Form>
    <Table border ref="selection" :loading="loading" :columns="columns" :data="data">
      <template slot-scope="{ row, index }" slot="empCode" style="width:100%">
        <Input v-model="row.empCode" @on-search="onSelectPeraon(row, index, 'empCode')" readonly search></Input>
      </template>
      <template slot-scope="{ row }" slot="userName" style="width:100%">
        <span>{{row.userName}}</span>
        <!-- <Input v-model="row.userName" :autosize="true" readonly @on-change="targetItemChange(row, index, 'userName')"/> -->
      </template>
      <template slot-scope="{ row }" slot="department" style="width:100%">
        <span>{{row.department}}</span>
        <!-- <Input v-model="row.department" :autosize="true" readonly @on-change="targetItemChange(row, index, 'department')"/> -->
      </template>
      <template slot-scope="{ row, index }" slot="year" style="width:100%">
        <DatePicker type="year"  v-model="row.year" transfer :autosize="true" @on-change="targetItemChange(row, index, 'year')"></DatePicker>
      </template>
      <template slot-scope="{ row, index }" slot="beAchStart" style="width:100%">
        <Checkbox v-model="row.beAchStart"  @on-change="targetItemChange(row, index, 'beAchStart')"></Checkbox>
      </template>
      <template slot-scope="{ row, index }" slot="beAchMid" style="width:100%">
        <Checkbox v-model="row.beAchMid" @on-change="targetItemChange(row, index, 'beAchMid')"></Checkbox>
      </template>
      <template slot-scope="{ row, index }" slot="beAchEnd" style="width:100%">
        <Checkbox v-model="row.beAchEnd" @on-change="targetItemChange(row, index, 'beAchEnd')"></Checkbox>
      </template>
      <template slot-scope="{ row, index }" slot="beAchUpdate" style="width:100%">
        <Checkbox v-model="row.beAchUpdate" @on-change="targetItemChange(row, index, 'beAchUpdate')"></Checkbox>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <!-- <Button type="warning"  size="small" style="margin-right: 8px" @click="editBtn(row, index)">{{$t('Save')}}</Button> -->
        <Button type="error" size="small" @click="deletedbtn(row, index)">{{$t('Delete')}}</Button><!--删除-->
      </template>
    </Table>
    <div style="margin:20px 0;">
      <Page style="float: left" :total="total" @on-change="pageChange"/>
      <Button style="float: right;margin-left:15px" type="primary" @click="fromCheck()" :disabled="loading">{{$t('Save')}}</Button><!--保存-->
      <Button style="float: right;margin-left:15px" type="primary" @click="addBtn()" :disabled="loading">{{$t('Add')}}</Button><!--新增-->
    </div>
    <selectPeopleVue ref="peoModal" @onSelect="onselect"/>
  </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "../../../util/DateUtil";
import selectPeopleVue from "./components/selectPeople.vue";
export default {
  components: { selectPeopleVue },
    data() {
        return {
            date: new DateUtil(),
            searchItem:{},
            loading:false,
            date: new DateUtil(),
            data: [],
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            targetIndex:''
        };
    },
    computed:{ 
      columns(){
        return[
                {
                    title: this.$t('Employee_Code'),//"工号"
                    slot: "empCode",
                    align: "center",
                    minWidth: 120,
                },{
                    title: this.$t('Name'),//"姓名"
                    slot: "userName",
                    align: "center",
                    minWidth: 120,
                },{
                    title: this.$t('Department'),//"部门"
                    slot: "department",
                    align: "center",
                    minWidth: 120,
                },{
                    title: this.$t('Year'),//"年份"
                    slot: "year",
                    align: "center",
                    minWidth: 100,
                },{
                    title: this.$t('Be_Objective_Setting'),//"是否允许发起年初目标申请"
                    slot: "beAchStart",
                    minWidth: 205,
                    align: "center",
                },{
                    title: this.$t('Be_Phase_Review'),//"是否允许发起阶段回顾"
                    slot: "beAchMid",
                    minWidth: 200,
                    align: "center",
                },{
                    title: this.$t('End_Year_Review'),//"是否允许发起年底总结"
                    slot: "beAchEnd",
                    minWidth: 200,
                    align: "center",
                },{
                    title: this.$t('是否允许发起目标修订'),//"是否允许发起目标修订"
                    slot: "beAchUpdate",
                    minWidth: 200,
                    align: "center",
                },{
                    title: this.$t('Action'),//"操作"
                    slot: "action",
                    align: "center",
                    minWidth: 100,
                },
            ]
      }
    },
    created(){
      this.getData()
    },

    methods: {
        getData(){
          // this.searchItem.date?this.searchItem.hireStartDate=this.date.dateVal(this.searchItem.date[0],'YYYY-MM-DD'):''
          // this.searchItem.date?this.searchItem.hireEndDate=this.date.dateVal(this.searchItem.date[1],'YYYY-MM-DD'):''
          let obj={
            ...this.pageInfo,
            ...this.searchItem
          }
          this.loading=true
          axios.post("/achSpecialApply/selectAchSpecialApplyInfo", obj).then((res) => {
            this.loading=false
              if(res){
                  this.data=res.data
                  this.total = parseInt(res.pageInfo.total)
                  this.data.forEach(el => {
                    el.beAchStart=!!(+el.beAchStart)
                    el.beAchMid=!!(+el.beAchMid)
                    el.beAchEnd=!!(+el.beAchEnd)
                    el.beAchUpdate=!!(+el.beAchUpdate)
                  })
              }
          })
        },
        targetItemChange(row, index, key) {
          if(key=="year")
          {
            this.$set(this.data[index], key, this.date.dateVal(row.year,"YYYY"));
            
          }else {
             key && this.$set(this.data[index], key, row[`${key}`]);
          }
         
        },
        deletedbtn(row,index){
          this.$Modal.confirm({
            title: this.$t('Are_you_sure_to_delete'),
            onOk: () => {
              if(row.id){
                axios.post("/achSpecialApply/deleteAchSpecialApplyInfo", {id:row.id}).then((res) => {
                    if(res){
                      this.$Message.success(res);
                      this.getData()
                    }
                })
              }else {
                this.data.splice(index,1)
              }
            }
          })
        },
        pageChange(){},
        addBtn(){
          this.data.push({
            empCode:'',
            userName:'',
            department:'',
            year:'',
            beAchStart:'',
            beAchMid:'',
            beAchEnd:'',
            beAchUpdate:''
          })
        },
        onSelectPeraon(row, index, key) {
          this.targetIndex=index
          let obj=JSON.parse(JSON.stringify(row))
          this.$refs.peoModal.modelColumns.unshift({
            title: this.$t("Select_Dev"), //选择
            slot: "action1",
            align: "center",
            minWidth: 70
          })
          this.$refs.peoModal.modal = true;
          this.$refs.peoModal.successorPeople = '3';
        },
        onselect(row){
          this.$set(this.data[this.targetIndex], 'serialnumber', row.serialnumber);
          this.$set(this.data[this.targetIndex], 'userName', row.userName);
          this.$set(this.data[this.targetIndex], 'empCode', row.empCode);
          this.$set(this.data[this.targetIndex], 'department', row.department);
        },
        save(){
          this.data.forEach(el => {
            el.beAchStart?el.beAchStart='1':el.beAchStart='0'
            el.beAchMid?el.beAchMid='1':el.beAchMid='0'
            el.beAchEnd?el.beAchEnd='1':el.beAchEnd='0'
            el.beAchUpdate?el.beAchUpdate='1':el.beAchUpdate='0'
          })
          axios.post("/achSpecialApply/saveAchSpecialApplyInfo", this.data).then((res) => {
              if(res){
                this.$Message.success(res);
                this.getData()
              }
          })
        },
        fromCheck(){
            if(this.data.filter(el => el.empCode=='').length>0){
                this.$Message.error(this.$t("Select_Employee"));//请选择员工
                return
            }
            if(this.data.filter(el => el.year=='').length>0){
                this.$Message.error(this.$t("Select_Year"));//请选择年份
                return
            }
            this.save()
        },
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/SpecialApply.vue